import { createFileRoute, Outlet, notFound } from "@tanstack/react-router";
import { loadDict } from "@/i18n/dictionaries";

/**
 * Layout para rotas localizadas (/en/*, /es/*).
 * Valida que `$locale` seja "en" ou "es"; caso contrário 404.
 * O LocaleProvider (em __root.tsx) lê o pathname e aplica o dicionário correto.
 *
 * O loader aquece o chunk do idioma ANTES do render (no SSR e na navegação no
 * cliente), então o HTML de /en e /es já sai traduzido — o import() dinâmico
 * tira EN/ES do bundle crítico sem custo de SEO.
 */
export const Route = createFileRoute("/$locale")({
  beforeLoad: ({ params }) => {
    if (params.locale !== "en" && params.locale !== "es") {
      throw notFound();
    }
  },
  loader: async ({ params }) => {
    await loadDict(params.locale === "es" ? "es" : "en");
  },
  component: () => <Outlet />,
});

